import { includes, isString } from 'lodash';

/*
  TooltipPropMixin validates for an object with, minimally, a key of "text"
  with a value of "String" and length over 0. eg:
  {
    text: 'The paragraph that will show in the tooltip.'
  }

  You can pass any number of key/values as long as the key "text" has a value
  longer than zero and every other value is a string with a length longer than zero.
  {
    text: 'paragraph of text...',
    kbLink: 'https://kb.jumpcloud.com/etc',
    kbLinkText: 'a link to the jumpcloud kb'
  }
*/

export default {
  props: {
    tooltip: {
      type: Object,
      default: undefined,
      validator(tooltipObj) {
        const tooltipKeys = Object.keys(tooltipObj);
        const required = includes(tooltipKeys, 'text');
        const strings = tooltipKeys.reduce(
          (_, cur) => isString(tooltipObj[cur]) && tooltipObj[cur].length > 0,
          false,
        );

        return required && strings;
      },
    },
  },
};
